import { Plus } from "lucide-react";
import { stories } from "@/lib/mockData";

export default function StoriesBar() {
  return (
    <div data-testid="stories-bar" className="border hairline bg-white rounded-2xl p-4 mb-5">
      <div className="flex items-center justify-between mb-3 px-1">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid">
          Historias · 24 h
        </p>
        <button className="text-xs text-coral hover:text-ink transition" data-testid="stories-see-all">
          Ver todas
        </button>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1 scrollbar-thin">
        {stories.map((s) => (
          <button
            key={s.id}
            data-testid={`story-${s.id}`}
            className="shrink-0 flex flex-col items-center gap-2 group"
          >
            <span className="relative inline-block">
              {s.me ? (
                <span className="block w-16 h-16 rounded-full p-[2px] bg-ink/10">
                  <img src={s.avatar} alt="" className="w-full h-full rounded-full object-cover bg-cream" />
                </span>
              ) : (
                <span
                  className={`block w-16 h-16 rounded-full p-[2.5px] ${
                    s.ring === "vinculos"
                      ? "bg-gradient-to-br from-coral via-coral-hover to-ink"
                      : "bg-gradient-to-br from-ink via-ink-mid to-coral"
                  }`}
                >
                  <span className="block w-full h-full rounded-full p-[2px] bg-cream">
                    <img src={s.avatar} alt="" className="w-full h-full rounded-full object-cover" />
                  </span>
                </span>
              )}
              {s.me && (
                <span className="absolute -bottom-0.5 -right-0.5 w-6 h-6 rounded-full bg-coral text-cream flex items-center justify-center ring-2 ring-white">
                  <Plus className="w-3.5 h-3.5" strokeWidth={2.5} />
                </span>
              )}
            </span>
            <span className="text-[11px] text-ink/80 max-w-[68px] truncate group-hover:text-ink">
              {s.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
